/** * Copyright (C), 2012-2021, Sichuan Xiaoka Technology Co., Ltd. * @file
资源管理-代下单-选择上下车位置 * */
<template>
  <el-dialog class="orderFormMap" append-to-body :visible.sync="visible"
             :title="type === 1 ? '选择上车位置' : '选择下车位置'"
             width="740px" :before-close="closeFn" :close-on-click-modal="false">
    <div class="map-search">
      <div>
        <span>地图搜索</span>
        <choose-address :value.sync="value" placeholder="在地图上搜索位置" :citycode="cityAdcode"
                        @clickRowFn="clickRowFn"></choose-address>
      </div>
      <div>
        <span>其他出发地</span>
        <el-select v-show="type == 1" @change="selectChange(1)" v-model="startRailNo" placeholder="请选择上车点">
          <el-option v-for="item in startStationRail" :key="item.id"
                     :label="item.stationName + (item.stationType == 1 ? ' (站点)' : ' (围栏)')" :value="item.railNo">
          </el-option>
        </el-select>
        <el-select v-show="type == 2" @change="selectChange(2)" v-model="endRailNo" placeholder="请选择下车点">
          <el-option v-for="item in endStationRail" :key="item.id"
                     :label="item.stationName + (item.stationType == 1 ? ' (站点)' : ' (围栏)')" :value="item.railNo">
          </el-option>
        </el-select>
      </div>
    </div>
    <div id="order-form-map"></div>
    <div v-if="type == 1" class="order-form-marker-text">
      {{ scope ? address.name : "上车点不在运营区域内" }}
      <span style="color: orange; margin-left: 16rpx" v-if="scope">¥{{ scope ? fee : "" }}起</span>
    </div>
    <div v-if="type == 2" class="order-form-marker-text">
      {{ scope ? address.name : "下车点不在运营区域内" }}
      <span style="color: orange; margin-left: 16rpx" v-if="scope">¥{{ scope ? fee : "" }}</span>
    </div>
    <img v-if="showPoint" class="order-form-marker" src="../../assets/img/marke.png" alt=""/>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="saveClick" :disabled="!scope">{{ type === 1 ? "确认上车点" : "确认下车点" }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import AMap from "AMap";

export default {
  name: "orderFormMap",
  props: {
    type: {
      // 地址类型，1-上车位置，2-下车位置
      default() {
        return 1;
      },
    },
    fences: {
      // 线路详情
      default() {
        return [];
      },
    },
    visible: {
      // 弹框显示/隐藏
      default() {
        return true;
      },
    },
    address: {
      // 选中的位置信息
      default() {
        return {};
      },
    },
    lineId: {
      default() {
        return null;
      },
    },
    lineType: {
      default() {
        return null;
      },
    },
    startRailNoSource: {
      default() {
        return null;
      }
    },
    endRailNoSource: {
      default() {
        return null;
      }
    },
    schedulingId: {
      default() {
        return null;
      }
    },
  },
  data() {
    return {
      map: null,
      marker: null,
      // 地图搜索-城市
      cityAdcode: "",
      // 地图搜索-默认值
      value: "",
      scope: false, // 是否在围栏内
      startRailNo: null,
      endRailNo: null,
      fee: null,
      startStationRail: [],
      endStationRail: [],
      chooseRail: null,
      showPoint: true,
    };
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            this.value = "";
            this.initMap();
          });
        }
      },
      immediate: true,
      deep: true,
    },
    startRailNoSource: {
      handler(val) {
        if (val) {
          this.startRailNo = val;
        }
      },
      immediate: true,
      deep: true
    },
    endRailNoSource: {
      handler(val) {
        if (val) {
          console.log(val);
          this.endRailNo = val;
        }
      },
      immediate: true,
      deep: true
    },
  },
  methods: {
    /* 下拉框变化 */
    selectChange(type) {
      // 拿到该站点/围栏
      this.chooseRail = this[type == 1 ? 'startStationRail' : 'endStationRail'].find(val => val.railNo == this[this.type == 1 ? 'startRailNo' : 'endRailNo'])
      if (this.Mark) {
        this.map.remove(this.Mark)
        this.Mark = null
      }

      // 定位
      if (this.chooseRail.stationType == 1) {
        this.showPoint = false;
        this.getMarker(this.chooseRail.longitude, this.chooseRail.latitude, 1, this.chooseRail.stationName)
        setTimeout(() => {
          this.drawMarker();
        }, 350);
        this.map.setStatus({
          dragEnable: false,
          zoomEnable: false,
        })
      } else {
        this.showPoint = true;
        let center;
        //最大经纬度与中间经纬度
        let longitudeMax = 0;
        let longitudeMin = 99999;

        let latitudeMax = 0;
        let latitudeMin = 99999;
        let path = JSON.parse(this.chooseRail.enclosureAddress);
        path[0][0].map((item) => {
          if (item.longitude > longitudeMax) {
            longitudeMax = item.longitude;
          } else if (item.longitude < longitudeMin) {
            longitudeMin = item.longitude;
          }

          if (item.latitude > latitudeMax) {
            latitudeMax = item.latitude;
          } else if (item.latitude < latitudeMin) {
            latitudeMin = item.latitude;
          }
        });
        center = [
          longitudeMin + (longitudeMax - longitudeMin) / 2,
          latitudeMin + (latitudeMax - latitudeMin) / 2,
        ];
        this.map.setCenter(center);
        setTimeout(() => {
          this.drawMarker();
        }, 350);
        this.map.setStatus({
          dragEnable: true,
          zoomEnable: true,
        })
      }
    },
    /* 地图搜索-选择单项 */
    async clickRowFn(res) {
      console.log(res,'======>>>>');
      this.value = null;
      this.chooseRail = null;
      this[this.type == 1 ? 'startRailNo' : 'endRailNo'] = null;
      this.map.setCenter([res.location.lng, res.location.lat]);
      setTimeout(() => {
        this.drawMarker();
      }, 500);
    },
    /* 绘制站点marker */
    getMarker(longitude, latitude) {
      let position = new AMap.LngLat(longitude, latitude);
      this.Mark = new AMap.Marker({
        map: this.map,                 // 地图实例对象
        position: position,            // 标记位置
        // anchor: "bottom-center",       // 设置锚点方位
        animation: "AMAP_ANIMATION_DROP", // 标记掉落效果
        icon: require("@/assets/img/markerBegin.png"),
        offset: new AMap.Pixel(-2, 0),
      });
      this.map.panTo(position);
    },
    /* 高德：绘制围栏多边形 */
    amapPolygon(path) {
      new AMap.Polygon({
        map: this.map,
        path: path,
        fillColor: "#0288FF",
        fillOpacity: "0.3",
        strokeColor: "#0288FF",
        strokeOpacity: 1,
      });
      this.map.setFitView();
    },
    /* 初始化地图 */
    initMap() {
      this.map = new AMap.Map("order-form-map", {
        mapStyle: 'amap://styles/572516903e2f1273ed9c97f54ebacd89',
        resizeEnable: true,
        center: new AMap.LngLat(104.065861, 30.657401),
      });

      // 等待地图加载完成后获取adcode
      this.map.on('complete', () => {
        this.cityAdcode = this.map.getAdcode();
        console.log('地图加载完成，cityAdcode:', this.cityAdcode);
      });
      
      // 立即尝试获取，作为备用
      setTimeout(() => {
        if (!this.cityAdcode) {
          this.cityAdcode = this.map.getAdcode();
          console.log('延迟获取 cityAdcode:', this.cityAdcode);
        }
      }, 500);

      // 缩放结束
      this.map.on("zoomend", () => {
        setTimeout(() => {
          this.drawMarker();
        }, 10)
      });
      // 拖拽结束
      this.map.on("dragend", () => {
        this.drawMarker()
      });

      this.startStationRail = this.fences[0].stationRail;
      this.endStationRail = this.fences[1].stationRail;
      if (!this.startRailNo && this.fences[0].stationType == 1) {
        this.startRailNo = this.startStationRail[0].railNo;
      }
      if (!this.endRailNo && this.fences[1].stationType == 1) {
        this.endRailNo = this.endStationRail[0].railNo;
      }

      this[this.type == 1 ? 'startStationRail' : 'endStationRail'].map(item => {
        if (item.stationType == 2) {
          this.amapPolygon(JSON.parse(item.enclosureAddress));
        }
      })
      if (this.type == 1) {
        if (!this.startRailNo) {
          this.startRailNo = this.startStationRail[0].railNo;
        }
        this.showPoint = this.startStationRail[0].stationType != 1;
        this.selectChange(1);
      } else if (this.type == 2) {
        if (!this.startRailNo) {
          this.startRailNo = this.startStationRail[0].railNo;
        }
        if (!this.endRailNo) {
          this.endRailNo = this.endStationRail[0].railNo;
        }
        this.showPoint = this.endStationRail[0].stationType != 1;
        this.selectChange(2);
      }

    },
    /* 视野变化 */
    async drawMarker() {
      // 获取地图中心点
      let resCenter = this.map.getCenter();
      if (resCenter.lat && resCenter.lng) {
        this.isFenceRange(resCenter.lat, resCenter.lng);
      }
      let lnglat = `${resCenter.lng},${resCenter.lat}`;
      let regeo = await this.$AMap.AMapReGeo(lnglat);
      let pois = regeo.regeocode.pois;
      pois.sort((a, b) => a.distance - b.distance);
      let name = pois && pois.length > 0 ? pois[0].name : regeo.regeocode.formatted_address;
      let addr = pois && pois.length > 0 && pois[0].address && pois[0].address.length > 0 ? pois[0].address : regeo.regeocode.formatted_address;

      if (this.type == 1) {
        if (this.startRailNo) {
          this.getPrice(
              this.type,
              this.lineId,
              this.startRailNo,
              null,
              this.schedulingId,
          );
        }
      } else {
        if (!this.scope) return
        this.getPrice(
            this.type,
            this.lineId,
            this.startRailNoSource,
            this.endRailNo,
            this.schedulingId,
        );
      }


      let address = {
        type: this.type,
        city: regeo.regeocode.addressComponent.city && regeo.regeocode.addressComponent.city.length > 0
            ? regeo.regeocode.addressComponent.city : regeo.regeocode.addressComponent.province,
        longitude: resCenter.lng,
        latitude: resCenter.lat,
        name: this.chooseRail.stationType == 1 ? this.chooseRail.stationName : name,
        address: addr,
      };
      this.$emit("update:address", address);
    },
    /* 获取价格 */
    async getPrice(type, lineId, startRailNo, endRailNo, schedulingId) {
      let url = "/api/v1/manage/order/manage/queryStartRailFee";
      let params = {type, startRailNo, endRailNo, lineId,schedulingId};
      let data = await this.$axios.get(url, params);
      if (data && data.code === 1) {
        this.fee = data.data.fee;
      }
    },
    isFenceRange(latitude, longitude) {
      if (this.chooseRail?.stationType == 1) {
        // if(this.address.name)
        this.scope = true;
      } else {
        let arr = [];

        this[this.type == 1 ? 'startStationRail' : 'endStationRail'].map((item) => {
          if (item.stationType == 2) {
            let oooj = this.isRange(JSON.parse(item.enclosureAddress), latitude, longitude, item);
            arr.push(oooj);
          }
        })

        let obj = arr.find((val) => val.bool == true);
        if (obj) {
          this.scope = true;
          this.chooseRail = obj.chooseRail;
          this[this.type == 1 ? 'startRailNo' : 'endRailNo'] = this.chooseRail.railNo;
        } else {
          this.scope = false;
          this.chooseRail = null;
          this[this.type == 1 ? 'startRailNo' : 'endRailNo'] = null;
        }
      }
    },
    /* 判断当前点是否在电子围栏以内 */
    isRange(path, latitude, longitude, chooseRail) {
      let obj;
      for (let index = 0; index < path.length; index++) {
        let item = path[index];
        if (item.length === 1) {
          let bool = this.customPointPolygon(latitude, longitude, item[0]);
          obj = {bool: bool, chooseRail: chooseRail};
          if (bool) {
            break;
          }
        } else if (item.length > 1) {
          let tag = false;
          item.forEach((val, i) => {
            if (i > 0) {
              let bool2 = this.customPointPolygon(latitude, longitude, item[i]);
              if (bool2) {
                tag = true;
              }
            }
          });
          let bool1 = this.customPointPolygon(latitude, longitude, item[0]);
          if (bool1) {
            if (!tag) {
              obj = {bool: true, chooseRail: chooseRail};
            } else {
              obj = {bool: false, chooseRail: chooseRail};
            }
            break;
          } else {
            obj = {bool: false, chooseRail: chooseRail};
          }
        }
      }
      return obj;
    },
    /**
     * 判断点是否在多边形范围以内
     * @param {*} aLat
     * @param {*} aLon
     * @param {*} pointList
     */
    customPointPolygon(aLat, aLon, pointList) {
      var iSum = 0;
      var iCount = pointList.length;
      if (iCount < 3) {
        return false;
      }
      for (var i = 0; i < iCount; i++) {
        var pLat2 = "";
        var pLon2 = "";
        var pLat1 = pointList[i].latitude;
        var pLon1 = pointList[i].longitude;
        if (i == iCount - 1) {
          pLat2 = pointList[0].latitude;
          pLon2 = pointList[0].longitude;
        } else {
          pLat2 = pointList[i + 1].latitude;
          pLon2 = pointList[i + 1].longitude;
        }
        if ((aLat >= pLat1 && aLat < pLat2) || (aLat >= pLat2 && aLat < pLat1)) {
          if (Math.abs(pLat1 - pLat2) > 0) {
            var pLon = pLon1 - ((pLon1 - pLon2) * (pLat1 - aLat)) / (pLat1 - pLat2);
            if (pLon < aLon) {
              iSum += 1;
            }
          }
        }
      }
      if (iSum % 2 != 0) {
        return true;
      } else {
        return false;
      }
    },

    closeFn() {
      this.endRailNo = null;
      this.$emit("update:visible", false);
    },
    saveClick() {
      if(!this.fee) {
        this.$message.warning('站点获取中，请稍后')
        return
      }
      if (this.type == 1) {
        this.$emit("startRailNo", this.startRailNo);
        if ([1, 4].includes(this.lineType)) {
          this.$emit("endRailNo", this.endRailNo);
        }
      } else {
        this.$emit("endRailNo", this.endRailNo);
        if ([1, 2].includes(this.lineType)) {
          this.$emit("startRailNo", this.startRailNo);
        }
      }
      this.$emit("fee", this.fee);
      this.$emit("confirm", this.address);
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style lang="less">
.orderFormMap {
  /deep/ .markerLabel {
    padding: 1rem 1.5rem;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    font-size: 1.5rem;
    color: #ffffff;
    box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.3);

    &.start {
      background-color: #0289ff91;
    }

    &.end {
      background-color: #228b2291;
    }
  }

  .map-search {
    display: flex;
    padding-bottom: 16px;
    align-items: center;

    & > div {
      margin-right: 40px;

      & > span {
        margin-right: 15px;
      }

      .el-select {
        width: 200px;

        .el-input__inner {
          padding-right: 15px;
        }
      }
    }
  }

  .el-dialog__body {
    position: relative;

    .order-form-marker {
      position: absolute;
      top: 50%;
      left: 50%;
      right: 50%;
      bottom: 50%;
      z-index: 10000;
      color: #0288ff;
      font-size: 20px;
      transform: translateX(-50%) translateY(-50%);
      margin-top: 10px;
    }

    .order-form-marker-text {
      position: absolute;
      top: calc(50% - 40px);
      left: 50%;
      transform: translateX(-50%);
      z-index: 10000;
      background-color: #fff;
      line-height: 17px;
      font-size: 14px;
      padding: 6px 16px;
      box-shadow: 2px 2px 6px 0px rgba(3, 136, 255, 0.2);
      border-radius: 14px;
      color: #061d37;
      white-space: nowrap;
      max-width: 80%;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  #order-form-map {
    width: 100%;
    height: 50vh;
    position: relative;
    z-index: 0;
  }
}
</style>
